import styled from 'styled-components'
import { Container as StartPageContainer } from '../../../components/start-page/styles'
import { BodyTitle, Head, TableCustom, TableTitle, TableTitleWrapper } from '../../../components/table/styles'

export const HardwareListPage = styled.div`
  min-width: 0;

  ${TableCustom} {
    table-layout: fixed;
  }

  th:last-child {
    width: 48px;
  }

  ${Head} {
    height: auto;
    min-height: 42px;
    padding: 8px 10px;
    box-sizing: border-box;
  }

  ${TableTitleWrapper}, ${TableTitle}, ${BodyTitle} {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  ${BodyTitle} {
    padding-right: 0;
  }

  @media (max-width: 720px) {
    ${StartPageContainer} {
      padding-right: 16px;
      padding-left: 16px;
    }
  }
`

export const FormCard = styled.div`
  width: 100%;
  max-width: 800px;
  box-sizing: border-box;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.grey[350]};
  border-radius: 8px;
  background: ${({ theme }) => theme.palette[20]};
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 640px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const FormActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
`

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.errors[600]};
  margin: 16px 0;
`
